module.exports = __webpack_public_path__ + "img/goods9.716f5593.jpg";